import { DatePipe, DecimalPipe, LowerCasePipe, NgClass, NgOptimizedImage, TitleCasePipe } from "@angular/common";
import { Component, input, InputSignal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { AmlScanEntity, IngoingTransaction, LatestAmlReport, ReportProcess } from "../../../../../../../api/api.model";
import { CropWithDotsCenterPipe } from "../../../../../../pipes/crop-with-dots-center.pipe";
import { CopyButtonComponent } from "../../../../../copy-button/copy-button.component";
import { InfoComponent } from "../../../../../info/info.component";
import { ReportStatusComponent } from "../../../../../report-status/report-status.component";
import { TriggerIdConvertToCategoryPipe } from "../../../../../../pipes/trigger-id-convert-to-category.pipe";
import { ConvertNetworkToTokenPipe } from "../../../../../../pipes/convert-netwrok-to-token.pipe";
import { CutNumberPipe } from "../../../../../../pipes/cut-number.pipe";


@Component({
  selector: 'app-transaction-incoming',
  standalone: true,
  imports: [
    DatePipe,
    NgOptimizedImage,
    CopyButtonComponent,
    NgClass,
    CropWithDotsCenterPipe,
    LowerCasePipe,
    InfoComponent,
    TitleCasePipe,
    ReportStatusComponent,
    MatIconModule,
    TranslateModule,
    TriggerIdConvertToCategoryPipe,
    ConvertNetworkToTokenPipe,
    CutNumberPipe
],
  templateUrl: './transaction-incoming.component.html',
  styleUrl: './transaction-incoming.component.scss'
})
export class TransactionIncomingComponent {
  public readonly transaction: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();
  public readonly process: InputSignal<ReportProcess> = input.required();

  ngOnInit(): void {
    console.log(this.transaction());
  }

  public asIngoingTransaction(transaction: AmlScanEntity<LatestAmlReport>): AmlScanEntity<IngoingTransaction> {
    return transaction as AmlScanEntity<IngoingTransaction>;
  }

  public calcPercentForExposures(value: number): number {
    return Math.round((value / this.transaction().amount) * 100 * 100) / 100;
  }
}
